import React from "react";
import Link from "next/link";

function CmsAttachment({ component, page_id='' }) {
    if(component.options.url != '') {
        return (
            <div className={`attachment`} id={`${component.id ?? ""}`}>
            <Link href={component.options.url}>
                <a target="_blank" className="downloadBtn">
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                    d="M8.4375 0C7.89063 0 7.5 0.429687 7.5 0.9375V7.5H4.0625C3.35937 7.5 3.00782 8.35937 3.51563 8.86718L9.45313 14.8047C9.72657 15.0781 10.2344 15.0781 10.5078 14.8047L16.4453 8.86718C16.9532 8.35937 16.6016 7.5 15.8984 7.5H12.5V0.9375C12.5 0.429687 12.0703 0 11.5625 0H8.4375ZM20 14.6875C20 14.1797 19.5703 13.75 19.0625 13.75H13.3203L11.4062 15.6641C10.625 16.4843 9.33593 16.4843 8.55468 15.6641L6.64063 13.75H0.9375C0.390625 13.75 0 14.1797 0 14.6875V19.0625C0 19.6093 0.390625 20 0.9375 20H19.0625C19.5703 20 20 19.6093 20 19.0625V14.6875ZM15.1562 18.125C15.1562 18.5547 14.8047 18.9063 14.375 18.9063C13.9453 18.9063 13.5937 18.5547 13.5937 18.125C13.5937 17.6953 13.9453 17.3437 14.375 17.3437C14.8047 17.3437 15.1562 17.6953 15.1562 18.125ZM17.6563 18.125C17.6563 18.5547 17.3047 18.9063 16.875 18.9063C16.4453 18.9063 16.0937 18.5547 16.0937 18.125C16.0937 17.6953 16.4453 17.3437 16.875 17.3437C17.3047 17.3437 17.6563 17.6953 17.6563 18.125Z"
                    fill="white"
                    />
                </svg>

                <span>{component.options.link_text != '' ? component.options.link_text : component.options.url}</span>
                </a>
            </Link>
            </div>
        );
    }
}

export default CmsAttachment;
